module.exports = __webpack_public_path__ + "static/media/flooring2.3efead6c.jpg";